
import { useQuery } from '@apollo/client';
import EDDialog from '../../../../../BaseComponents/Dialog/EDDialog';
import { EDListItemButton } from '../../../../../BaseComponents/List/Components/EDListItem';
import EDList from '../../../../../BaseComponents/List/EDList';
import EDTypography from '../../../../../BaseComponents/Typography/EDTypography';
import HelpQuery from '../Queries/HelpQuery.gql';
import {
  HelpQuery as IHelpQuery,
  HelpQueryVariables as IHelpQueryVariables,
} from '../Queries/_QueryTypes/HelpQuery';

interface IProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  programLocationHeader: string;
}

const HelpDialog: React.FC<React.PropsWithChildren<IProps>> = props => {
  const queryResult = useQuery<IHelpQuery, IHelpQueryVariables>(HelpQuery, {
    skip: !props.programLocationHeader || !props.open,
    variables: {
      name: props.programLocationHeader.toLowerCase(),
      link: 'main',
    },
  });

  const helpResponse = queryResult.data;

  return (
    <EDDialog
      open={props.open}
      onClose={() => {
        props.setOpen(false);
      }}
      title={`Hjälp för ${props.programLocationHeader}`}
      footerActions={[
        {
          label: 'Stäng',
          onClick: () => {
            props.setOpen(false);
          },
        },
      ]}
    >
      <>
        {queryResult.loading ? (
          <EDTypography>Laddar hjälpavsnitt</EDTypography>
        ) : queryResult.error ? (
          <EDTypography>{`Fel vid hämtning av hjälpavsnitt: ${queryResult.error.message}`}</EDTypography>
        ) : helpResponse?.help && helpResponse?.help.length > 0 ? (
          <>
            <EDTypography>Välj ett hjälpavsnitt</EDTypography>
            <EDList>
              {helpResponse.help.map((help, index) => (
                <a
                  key={index}
                  href={help.url}
                  target="_blank"
                  onClick={() => {
                    props.setOpen(false);
                  }}
                  data-testid={help.title}
                >
                  <EDListItemButton>{help.title}</EDListItemButton>
                </a>
              ))}
            </EDList>
          </>
        ) : (
          <EDTypography>Hjälpavsnitt saknas</EDTypography>
        )}
      </>
    </EDDialog>
  );
};

export default HelpDialog;
